import { useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { ClassesAllGradesQuery } from '../../graphQLOperations/__generated__/ClassesAllGradesQuery.graphql';
import { allGrades } from '../../graphQLOperations/Classes';
import { Grade } from '../../models/Grade';

interface Props {
  setAllGradeLevels: (gradeLevels: Grade[]) => void;
}

const QueryGetAllGradeLevels = ({ setAllGradeLevels }: Props) => {
  const { allGradeLevels } = useLazyLoadQuery<ClassesAllGradesQuery>(allGrades, {}, { fetchPolicy: 'network-only' });

  useEffect(() => {
    if (allGradeLevels && allGradeLevels.length) {
      setAllGradeLevels(allGradeLevels as Grade[]);
    }
  }, allGradeLevels);
  return <div style={{ display: 'none' }}></div>;
};

export default QueryGetAllGradeLevels;
